<dx-box width="100%" height="100%" direction="col" class="cc-white-background conflict-popover-container">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <div class="title-container dx-theme-border-color">
                <div class="title cc-text-bold">
                    {{ conflictField.fieldName }}
                </div>
                <i class="icons" [ngClass]="iconClose" (click)="onCloseConflict()"></i>
            </div>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <dx-box width="100%" height="100%" direction="col" class="conflict-box">
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <div class="field-container">
                            <div class="field-label res-content">
                                Scanned Info (by&nbsp;
                                <app-user-bio-link [user]="scannedBy" [communityId]="communityId"></app-user-bio-link>
                                )
                            </div>
                            <div class="field-component">
                                <dx-button
                                    type="default"
                                    text="Use Scanned Info"
                                    (onClick)="onScannedInfoClick()"
                                ></dx-button>
                            </div>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <div class="field-container cc-text-bold">
                            {{ conflictField.scannedStepValue.displayText }}
                        </div>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <div class="field-container">
                            <div class="field-label res-content">
                                Verify Info (by&nbsp;
                                <app-user-bio-link [user]="verifiedBy" [communityId]="communityId"></app-user-bio-link>
                                )
                            </div>
                            <div class="field-component">
                                <dx-button
                                    type="default"
                                    text="Use Verify Info"
                                    (onClick)="onVerifyInfoClick()"
                                ></dx-button>
                            </div>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <div class="field-container cc-text-bold">
                            {{ conflictField.verifyStepValue.displayText }}
                        </div>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
</dx-box>
